import {IdCodeNameModel} from 'common-shared';
import {Type} from "class-transformer";
import {SpecLineModel} from "web-shared";

export class ProcessModel extends IdCodeNameModel {
  constructor(init?: Partial<ProcessModel>) {
    super();
    Object.assign(this, init);
  }

  Comment: string;
  Number: number;
  WorkCenterId: string;
  ExecutionModeClv: string;

  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  From: string[];
  To: string[];

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }
}
